/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const MODAL_CONFIRM_CHANGING_PLAN = 'confirmChangingPlan'
